var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3083",
    transform: "translate(-415 172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2842",
    "data-name": "Group 2842",
    transform: "translate(415 -172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M-1626.682,143.893h-17.175a6.711,6.711,0,0,1-6.413-6.961V120.854a6.712,6.712,0,0,1,6.413-6.961h17.175a6.711,6.711,0,0,1,6.412,6.961v16.078A6.711,6.711,0,0,1-1626.682,143.893Zm-17.175-27.871a4.659,4.659,0,0,0-4.452,4.832v16.078a4.659,4.659,0,0,0,4.452,4.832h17.175a4.659,4.659,0,0,0,4.451-4.832V120.854a4.659,4.659,0,0,0-4.451-4.832Z",
    transform: "translate(1650.27 -113.893)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x2: 16,
    transform: "translate(422 -164.5)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 16,
    transform: "translate(422 -159.5)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 16,
    transform: "translate(422 -154.5)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 6.5,
    transform: "translate(422 -149.5)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.e80c2f439155e161120bf7da60c38e7d.svg";
export { ForwardRef as ReactComponent };